module.exports = __webpack_public_path__ + "static/img/scgqh.031a637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scgqh.png
// module id = 4wEZ
// module chunks = 0